export const isSafeMediaUrl = (url?: string) => {
  if (!url) return false;

  try {
    return ['http:', 'https:'].includes(new URL(url).protocol);
  } catch {
    return false;
  }
};

export const getMediaKey = (url: string) => {
  try {
    const { origin, pathname } = new URL(url);

    return `${origin}${pathname}`;
  } catch {
    return url;
  }
};
